<template>
  <div style="text-align: center;">
    <!--<iframe
      class="iframe-blog"
      :src="blogURL"
    ></iframe>-->
    <vs-button class="ml-auto mt-2" :href="blogURL" target="_blog">Manage Blog</vs-button>
  </div>
</template>

<script>
export default {
  name: 'BlogList',
  data () {
    return {
      blogURL: `${process.env.VUE_APP_API_URL}/login-blog/${parseInt(JSON.parse(localStorage.getItem('userInfo')).uid) * 3}`
    }
  },
  created () {
    this.$emit('changeRouteTitle', 'Blog')
    window.open(
      this.blogURL,
      '_blog'
    )
  }
}
</script>

<style scoped>
  .iframe-blog {
    border: 0px;
    width: -webkit-fill-available;
    height: -webkit-fill-available;
  }
</style>
